<template>
  <div id="app" v-loading="loading">
    <div class="app-header">
      <el-menu
        :default-active="activeMenu"
        mode="horizontal"
        :router="true">

        <!--星云链 -->
        <li style="float: left;width: 70px;">
          <img src="../../static/logo.png" style="width: 50px;height:40px; margin-top:10px;"/>
        </li>

        <!-- logo -->
        <li style="float: left;width: 100px;">
          <img src="../../static/logo-shejianping.png" style="width: 100px;height:40px; margin-top:10px;"/>
        </li>
        <!-- logo -->

        <li style="float: left;width: 100px;">
          <img src="../../static/logo-wenzi.png" style="width: 100px;height:40px; margin-top:10px;"/>
        </li>

        <el-menu-item  v-for="(menu, index) in menuAuth" :key="index" :index="index" v-if="menu.show">{{menu.desc}}
        </el-menu-item>

        <!-- 提示信息显示 -->
        <li style="float: right;height: 60px;line-height: 60px;color:#909399;font-size: 14px">
          <a class="account-num" v-if="!accountsError">
            {{accounts[0]}}
          </a>

          <span v-if="accountsError">
            <span>{{accountsError}}</span>
          </span>
          &nbsp;
        </li>

      </el-menu>
    </div>

    <!--显示区域-->
    <div class="app-content">
      <router-view></router-view>
    </div>

    <div class="app-footer">
      使用 <a href="https://nebulas.io" target="_blank">星云链</a> 驱动&nbsp;
      |&nbsp;<a href="mailto:86369340@qq.com">联系作者</a>&nbsp;
      |&nbsp;<a href="https://incentive.nebulas.io/cn/signup.html?invite=rairw" target="_blank">提交DAPP获得100NAS币</a>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import _ from 'lodash'

export default {
  data () {
    return {
      loading: false,
      userName: 'U',
      menuAuth: {
        index: {show: true, desc: '首页'},
        publish: {show: true, desc: '分享美食'},
        mine: {show: true, desc: '我的分享'},
        help: {show: true, desc: '关于'},
        detail: {auth: true, desc: '详情'}
      }
    }
  },
  methods: {
    goHelp: function () {
      this.$router.push('/help')
    },
    goSignUp: function () {
      console.log('here')
      this.$router.push('/signUp')
    },
    // 加载钱包账户
    loadBaseAcc: function () {
      var vueThis = this
      vueThis.$store.dispatch('initBaseAccount').then(() => {
        // 菜单权限展示控制
        vueThis.isValidRouteAuth();
      }, function (error) {
        // vueThis.showErr(error);
        console.log('initBaseAccount error', error);
        vueThis.isValidRouteAuth()
      })
    },
    // 菜单权限展示控制
    isValidRouteAuth: function (to) {
      let vueThis = this
      vueThis.loading = true;
      // 这里根据业务场景可以限制vueThis.menuAuth中具体菜单的show属性值
      let menuKey = to ? to.name : vueThis.$route.name;
      // 权限
      if (!vueThis.menuAuth[menuKey].show && !vueThis.menuAuth[menuKey].auth) {
        vueThis.$router.push('/help')
      }
      vueThis.loading = false;
    }
  },
  created () {
    this.loadBaseAcc()
  },
  computed: mapState([
    'activeMenu',
    'accounts',
    'needSingUp',
    'accountsError',
    'user'
  ]),
  watch: {
    user (curVal, oldVal) {
      if (!_.isEqual(curVal, oldVal)) {
        console.log('检测用户发生变化，重新登录')
        this.isValidRouteAuth()
      }
    },
    $route (to) {
      console.log('to==', to)
      this.isValidRouteAuth(to)
    }
  }
}
</script>

<style scoped>
  #app{
    padding-left:80px;
    padding-right:80px;
  }

  #app .app-header{
    font-size: 16px;
  }

  #app .app-content{
    padding-top: 15px;
    min-height: 500px;
  }

  #app .app-footer {
    color: #606266;
    margin-top: 45px;
    padding: 35px;
    text-align: center;
    font-size: 14px;
    border-top: 1px solid #DCDFE6
  }
  #app .app-footer a{
    color: #606266;
  }
</style>



// WEBPACK FOOTER //
// src/components/app.vue